// Temporary product-portfolio controls.  These modules remain registered so
// old links and retained historical records are not broken, but they are not
// offered in the navigation, module search, or report/audit selectors until
// the product team explicitly re-enables them.
const HIDDEN_MODULE_PATHS = new Set([
  "/von-hubinterface",
  "/hubspotinfo",
  "/hubspotarchive",
]);

const HIDDEN_MODULE_NAMES = new Set([
  "vonage hub",
  "von-hub interface",
  "von hub interface",
  "hubspot email",
  "hubspot info",
  "hubspot emails info",
  "hubspot archive",
]);

export const HIDDEN_AUDIT_MODULE_CODES = new Set([
  "vonage_hub",
  "hubspot_email",
  "hubspot_archive",
]);

const normalized = (value) => String(value || "").trim().toLowerCase();

/** True only for modules intentionally paused from the current CRM surface. */
export function isTemporarilyHiddenModule(moduleOrName, route = "") {
  const module = moduleOrName && typeof moduleOrName === "object"
    ? moduleOrName
    : null;
  const name = normalized(module ? module.name : moduleOrName);
  const path = normalized(route || module?.route);

  return HIDDEN_MODULE_NAMES.has(name) || HIDDEN_MODULE_PATHS.has(path);
}

export function isTemporarilyHiddenAuditModule(moduleCode) {
  return HIDDEN_AUDIT_MODULE_CODES.has(normalized(moduleCode));
}
